module.exports = __webpack_public_path__ + "img/logo8.71959dbe.png";